import _ from 'lodash';
import { Space, ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import classNames from 'classnames';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import './MainLayout.css';
import { Accountant } from '../../modules/Accountant/Accountant';
import { Overview } from '../../modules/Overview/Overview'; 
import { CommonTradings } from '../../modules/CommonTrading/CommonTrading';
import { FullBills } from '../../modules/FullBills/FullBills';
import { RiskAnalysis } from '../../modules/RiskAnalysis/RiskAnalysis';
import { Statement } from '../../modules/Statement/Statement';
import { UserInfo } from '../../modules/UserInfo/UserInfo';

dayjs.locale('zh-cn');

export function MainLayout ({ visible }) {
    //风险分析
    //收入、支出统计
    //金融支出与正常交易占比
    //消费足迹
    return <main className={classNames({ 'main': true, 'hide': !visible })}>
        <ConfigProvider locale={zhCN}>
            <Space direction="vertical" size="middle">
                <UserInfo />
                <RiskAnalysis />
                <Accountant />
                <Overview />
                <CommonTradings />
                <FullBills />
                <Statement />
            </Space>
        </ConfigProvider>
    </main>
}